<!--<burncase-loading #loading *ngIf="drawViewService.isLoading && !applicationService.appStarted"></burncase-loading>-->
<div style="height: 100%">
    <mat-tab-group (selectedTabChange)="collectData($event)" animationDuration="0" selectedIndex="1">
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon>accessibility</mat-icon>
                {{'Model' | translate}}
            </ng-template>
            <burncase-model-selection (window:resize)="onResize()"></burncase-model-selection>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <s3design-icon [name]="'brush'"></s3design-icon>
                {{'Draw' | translate}}
            </ng-template>
            <burncase-draw-view (window:resize)="onResize()"></burncase-draw-view>
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon>view_list</mat-icon>
                {{'Results' | translate}}
            </ng-template>
            <burncase-tbsa-results
                    (window:resize)="onResize()"
                    [data]="navigationService.data"
                    [finish]="navigationService.finish"
                    [parkland]="navigationService.parkland"
                    [total]="navigationService.total"
            ></burncase-tbsa-results>
        </mat-tab>
    </mat-tab-group>

    <div #mainSurfaceView class="mainSurfaceView">
        <surface-view #surfaceView [reload]="true"></surface-view>
    </div>
</div>



